import { MediaPlaceholder } from '@/components/patterns/media-placeholder'
import { useState } from 'react'

function FsnImportLogoPreview({ logoUrl }) {
  const [failed, setFailed] = useState(false)

  if (!logoUrl || failed) {
    return <MediaPlaceholder label="No usable logo preview" size="preview" />
  }

  return (
    <div className="flex h-32 items-center justify-center rounded-md border border-border/70 bg-background p-3">
      <img
        src={logoUrl}
        alt="FSN logo preview"
        className="max-h-24 max-w-full object-contain"
        onError={() => setFailed(true)}
      />
    </div>
  )
}

export { FsnImportLogoPreview }
